class SerializableError extends Error {
  constructor(error, details) {
    var __super = (...args) => {
      super(...args);
    };
    if (error instanceof Error) {
      __super(error.message);
      this.stack = error.stack;
      this.cause = error.cause;
    } else {
      __super(error);
    }
    this.details = details;
  }
  serialize() {
    return {
      ...this,
      message: this.message,
      details: {
        ...this.details
      }
    };
  }
}
export {
  SerializableError
};
//# sourceMappingURL=serializable-error.js.map
